import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {
	Button,
} from "@mui/material";
import data from '../data/session.json';

export default function SessionScoresChart({ gotoanalytics }) {
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Session Quality Scores</h2>
	<Button color="inherit" onClick={gotoanalytics} sx={{ mr: 1 }}>
		Analytics
	</Button>
	<br/>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data.sessions} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="name" angle={-45} textAnchor="end" interval={0} height={80} />
          <YAxis domain={[0, 10]} />
          <Tooltip />
          <Legend />
          <Bar dataKey="empathy" fill="#8884d8" />
          <Bar dataKey="patience" fill="#82ca9d" />
          <Bar dataKey="responsiveness" fill="#ffc658" />
          <Bar dataKey="compliance" fill="#ff7f50" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

